import { AnimationControls, animate, spring } from 'motion';
import BasePage from '../../components/base-page/base-page';
import type { UiElement } from '../../../shared/ui-element/ui-element';

import './about.scss';

class AboutPage extends BasePage {
  ui = {
    heroMacpawBadge: '.js-hero-macpaw-badge',
  };

  uiCollections = {
    heroBadges: '.js-hero-section-badge',
  };

  events = {
    'mouseenter @uiCollections.heroBadges': 'handleBadgeMouseEnter',
    'mouseleave @uiCollections.heroBadges': 'handleBadgeMouseLeave',
    'mouseenter @ui.heroMacpawBadge': 'handleMacpawBadgeMouseEnter',
  };

  badgeRotationAnimation: AnimationControls | null = null;

  handleBadgeMouseEnter = ({ target }) => {
    animate(target,
      { rotate: target.dataset.rotateByHoverTo, scale: 1.1 },
      { easing: spring({ stiffness: 500, damping: 15 }) }
    );
  };

  handleBadgeMouseLeave = ({ target }) => {
    animate(target,
      { rotate: 0, scale: 1 },
      { easing: spring({ stiffness: 500, damping: 15 }) }
    );
  };

  handleMacpawBadgeMouseEnter = ({ target }) => {
    if (this.badgeRotationAnimation && this.badgeRotationAnimation.playState === 'running') {
      return;
    }

    this.badgeRotationAnimation = animate(target,
      { transform: ['rotate(0deg)', 'rotate(360deg)'] },
      { duration: 0.8, easing: 'ease-in-out' }
    );
  };
}

export default AboutPage;

(AboutPage as UiElement).initOnDomLoaded();
